import {
  GET_SCREENERS
} from "@actions/project/screeners"
import { get } from "@api/fetch"

/**
 * Gets a file request for a project
 *
 * @returns {Function}
 */

export const getScreeners = (search, sorting) => (dispatch, getState) =>
  dispatch(get(GET_SCREENERS, `projects/${getState().project.details._id}/screeners?search=${encodeURIComponent(search || "")}&sortKey=${sorting.key}&sortDirection=${sorting.direction}`))

